module.exports = __webpack_public_path__ + "static/media/suporte.93810263.svg";